import { StageStatusBadge } from '../StageStatusBadge';
import { ViewTogglePane } from '../ViewTogglePane';
import type { FlowStageStatus, FlowViewMode } from '../types';

export interface FlowContextHeaderProps {
  stageTitle: string;
  stageStatus: FlowStageStatus;
  activeView: FlowViewMode;
  onViewChange: (view: FlowViewMode) => void;
  className?: string;
}

export function FlowContextHeader({
  stageTitle,
  stageStatus,
  activeView,
  onViewChange,
  className,
}: FlowContextHeaderProps) {
  return (
    <div
      className={className ?? 'flex w-full items-center justify-between p-4'}
    >
      <div className="flex items-center gap-2">
        <span className="text-xl leading-7 font-medium text-zinc-300">
          Stage: {stageTitle}
        </span>
        <StageStatusBadge status={stageStatus} />
      </div>
      <ViewTogglePane
        activeView={activeView}
        onViewChange={onViewChange}
        className="flex items-center gap-4"
      />
    </div>
  );
}
